/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
/**
 * CSS Custom Properties
 *
 * These properties can be overridden using the component's tag as selector.
 *
 * @prop --calcite-accordion-border-color: Specifies the component's border color.
 * @prop --calcite-accordion-background-color:  Specifies the component's background color.
*/
:host {
  position: relative;
  display: block;
  max-inline-size: 100%;
  line-height: 1.5rem;
}

.accordion {
  border-width: 1px;
  border-block-end-width: 0px;
  border-style: solid;
  border-color: var(--calcite-accordion-border-color, var(--calcite-color-border-2));
  background-color: var(--calcite-accordion-background-color, var(--calcite-color-foreground-1));
}

.accordion--transparent {
  --calcite-accordion-border-color: transparent;
  border-color: var(--calcite-color-transparent);
  background-color: var(--calcite-color-transparent);
}

:host([scale=s]) {
  --calcite-internal-accordion-item-spacing-unit: 0.25rem;
  --calcite-internal-accordion-icon-margin: 0.5rem;
  --calcite-internal-accordion-item-padding: var(--calcite-internal-accordion-item-spacing-unit) 0.5rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
}

:host([scale=m]) {
  --calcite-internal-accordion-item-spacing-unit: 0.5rem;
  --calcite-internal-accordion-icon-margin: 0.75rem;
  --calcite-internal-accordion-item-padding: var(--calcite-internal-accordion-item-spacing-unit) 0.75rem;
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
}

:host([scale=l]) {
  --calcite-internal-accordion-item-spacing-unit: 0.75rem;
  --calcite-internal-accordion-icon-margin: 1rem;
  --calcite-internal-accordion-item-padding: var(--calcite-internal-accordion-item-spacing-unit) 1rem;
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}